var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('delete-confirmation-modal',{ref:"delete",attrs:{"title":_vm.title,"text":_vm.text,"confirmMessage":_vm.confirmMessage,"hasExternalPopup":_vm.hasExternalPopup},on:{"confirm":_vm.exclude,"cancel":_vm.cancel}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-168ec0a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/components/ModalDelete.vue
// module id = null
// module chunks = 